'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from '../../hooks';
import { FeedbackButtonV2, FeedbackSkeletonV2 } from './components';
import { useMedalliaForm, useMedalliaFormV2 } from './hooks';
export function MedalliaFeedbackButtonV2() {
  const $ = _c(8);
  const isOneTrust = useDecisions("onetrust");
  const t0 = !isOneTrust;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      isActive: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const buttonConfigLegacy = useMedalliaForm(t1);
  let t2;
  if ($[2] !== isOneTrust) {
    t2 = {
      isActive: isOneTrust
    };
    $[2] = isOneTrust;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const buttonConfigV2 = useMedalliaFormV2(t2);
  const {
    formState,
    onOpen
  } = isOneTrust ? buttonConfigV2 : buttonConfigLegacy;
  if (formState === "blocked") {
    return null;
  }
  if (formState === "loading") {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <FeedbackSkeletonV2 />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  const t3 = formState === "error";
  let t4;
  if ($[5] !== onOpen || $[6] !== t3) {
    t4 = <FeedbackButtonV2 isError={t3} onOpen={onOpen} />;
    $[5] = onOpen;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}